import { Box, type BoxProps, CircularProgress, type CircularProgressProps } from '@mui/material';

import { colors } from '@styles/theme';

type Props = CircularProgressProps & {
  boxContainerProps?: BoxProps;
  boxContainerSx?: BoxProps['sx'];
  size?: number;
  thickness?: number;
};

export const LoadingSpinner = ({
  boxContainerProps,
  boxContainerSx,
  size = 70,
  thickness = 6,
  ...circularProgressProps
}: Props) => {
  const circularProgressSx = circularProgressProps.sx
    ? { ...circularProgressProps.sx }
    : { strokeLinecap: 'round' };

  const boxContainerSxProps: BoxProps['sx'] = {
    display: 'flex',
    width: '100%',
    height: '100%',
    minHeight: 200,
    alignItems: 'center',
    justifyContent: 'center',
    ...boxContainerSx,
  };

  return (
    <Box sx={boxContainerSxProps} {...boxContainerProps}>
      <Box
        sx={{
          position: 'relative',
          display: 'inline-flex',
          borderRadius: '50%',
          boxShadow: `inset 0 0 1px 7px ${colors.component.inputBorderColor}`,
        }}>
        <CircularProgress
          size={size}
          thickness={thickness}
          sx={{
            color: colors.gradientPrimary.main,
            ...circularProgressSx,
          }}
          {...circularProgressProps}
        />
      </Box>
    </Box>
  );
};
